import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const navSubMenuFn = /* @__PURE__ */ createRecipe('nav-sub-menu', {}, [])

const navSubMenuVariantMap = {}

const navSubMenuVariantKeys = Object.keys(navSubMenuVariantMap)

export const navSubMenu = /* @__PURE__ */ Object.assign(memo(navSubMenuFn.recipeFn), {
  __recipe__: true,
  __name__: 'navSubMenu',
  __getCompoundVariantCss__: navSubMenuFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: navSubMenuVariantKeys,
  variantMap: navSubMenuVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, navSubMenuVariantKeys)
  },
  getVariantProps: navSubMenuFn.getVariantProps,
})